<template>
	<!-- 产品类型历史记录 -->
	<lcsj-dialog v-model="dialogVisible" @close="handleClose" title="选择申请采购的商品" width="80%" cancel-text="关闭" confirm-text="确定"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleOk">
		<lcsj-filter @search="getListData">
			<el-form-item label="类型：">
				<el-select v-model="formInline.typeName" placeholder="请选择类型" clearable size="small" filterable @change="handleTypeNameChange">
					<el-option v-for="item in typeNameList" :key="item.value" :label="item.value" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="系列：">
				<el-select v-model="formInline.productName" placeholder="请选择系列" clearable size="small" filterable @change="getListData">
					<el-option v-for="item in subNameList" :key="item.value" :label="item.value" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品名称：">
				<el-input v-model="formInline.specification" placeholder="请输入商品名称" clearable size="small"></el-input>
			</el-form-item>
		</lcsj-filter>
		<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass"
			v-loading="loading"
			:data="listData"
			border
			stripe
			height="535px"
			:highlight-selection-row="false"
			empty-text="暂无数据"
			
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="60" align="center"></el-table-column>
			<el-table-column prop="rowNumber" label="序号" width="60" align="center"></el-table-column>
			<el-table-column prop="typeName" label="类型" width="150" align="center"></el-table-column>
			<el-table-column prop="productName" label="系列" width="180" align="center"></el-table-column>
			<el-table-column prop="specification" label="商品名称" align="center"></el-table-column>
			<el-table-column prop="price" label="价格(元)" width="100" align="center"></el-table-column>
			<el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
			<el-table-column prop="creator" label="创建人" width="120" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination></lcsj-dialog>
</template>

<script>
import { GetProductTypePageList, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			title: "",
			loading: false, //是显示加载
			dialogVisible: false, //控制编辑页面显示与隐藏
			listData: [],
			pageShow: true,
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				typeName: "",
				productName: "",
				specification: "",
				isWareHouse: null
			},
			selectedRows: [],
			// 产品类型名称列表
			typeNameList: [],
			// 产品类型子名称列表
			subNameList: []
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		showSelectProductTypeDialog(keyId, isRealHouse) {
			this.formInline.storeKeyId = keyId;
			this.formInline.isWareHouse = isRealHouse;
			this.getListData();
			this.dialogVisible = true;
			this.selectedRows = [];
			this.getProductTypeNameList();
			this.getProductTypeSubNameList("");
		},
		getListData() {
			this.loading = true;
			GetProductTypePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 关闭编辑、增加弹出框
		handleClose() {
			this.dialogVisible = false;
			this.listData = [];
			this.selectedRows = [];
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 处理选择行事件
		handleSelectionChange(selection) {
			this.selectedRows = selection;
		},
		// 处理确定按钮点击事件
		handleOk() {
			if (this.selectedRows.length === 0) {
				this.$message({
					type: "warning",
					message: "请选择要确定的记录"
				});
				return;
			}
			// 处理确定逻辑
			this.$parent.handleProductTypeChange(this.selectedRows);
			this.handleClose();
		},
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.typeNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getProductTypeSubNameList(code) {
			var params = {
				code: code
			};
			GetProductTypeSubNameList(params).then((res) => {
				if (res.code == 1) {
					this.subNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.subNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 类型名称改变事件
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.getListData();
		}
	}
};
</script>
<style scoped></style>
